import { ReactNode } from 'react'
import styled from 'styled-components'

type SquareBoxItemProps = {
  selected: boolean
  children: ReactNode
}

const StiledSquareBox = styled.div<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 90px;
  height: 90px;
  background-color: ${(props) => (props.$selected ? "#e7f7ee" : "white")};
  //background-color: white;
  //border: 1px solid #4caf8a;
  border-radius: 12px;
  transition: all 0.2s ease-in-out;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  //box-shadow: ${({ $selected }) => $selected ? '0 2px 8px rgba(0, 0, 0, 0.3)' : 'none'};
  color: ${(props) => (props.$selected ? "#4caf8a" : "#555")};
  font-size: 14px;
  font-weight: 500;
  /* 
  &:hover {
    background-color: ${(props) => (props.$selected ? "#d5f0e2" : "#f9f9f9")};
    //background-color: #e7f7ee;
    color: #4caf8a;
  }
  */
`

export function SquareBoxItem ({ selected = false, children }: SquareBoxItemProps) {
  return (
    <StiledSquareBox $selected={selected}>
      {children}
    </StiledSquareBox>
  )
}
